import React from "react";
import { Popup as Modal } from "reactjs-popup";

import DeclinedPopup from "../../../../ServiceRequest/Popup";
import { updateBulkStatus } from "../../../../../services/client";
import { useSelector } from "react-redux";
import { selectAuthenticatedUser } from "../../../../../store/selectors/auth";
import { toast } from "react-toastify";

export const DeclinedStatusOverlay = ({
  showDeclinedStatusOverlay,
  setShowDeclinedStatusOverlay,
  serviceRequestIds,
  fetchDashboard
}) => {
  const user = useSelector(selectAuthenticatedUser);
  const onSubmitPopup = (type, data) => {
    setShowDeclinedStatusOverlay(false);
    if (type === "cancel") {
      return;
    }
    updateBulkStatus({
      serviceRequest: serviceRequestIds.map((sr) => ({ id: sr })),
      name: "Declined",
      userId: user.id,
      Reason: data.description,
      ReasonType: data.reason,
    }).then((res) => {
      if (res.status === 200) {
        toast.success("Service requests updated successfully", {
          autoClose: 5000,
          position: "top-center",
        });
        fetchDashboard();
      } else {
        toast.error(
          "🚫 Failed to update service requests, please try again later.",
          { autoClose: 5000, position: "top-center" }
        );
      }
    });
  };
  return (
    <>
      <Modal
        open={showDeclinedStatusOverlay}
        onClose={() => setShowDeclinedStatusOverlay(false)}
        closeOnDocumentClick={false}
        className="popup-content"
      >
        <DeclinedPopup
          onSubmitPopup={(type, data) => onSubmitPopup(type, data)}
        />
      </Modal>
    </>
  );
};
